<section class="testimonials-section">
  @if(!loader && reviews.length > 0){
  <div class="section-content">
    <div class="header-content" data-aos="fade-up">
      <h2 class="main-title">Lo Que Dicen Nuestros Clientes</h2>
      <p class="subtitle">Nuestros clientes nos envían un montón de sonrisas con sus servicios y los amamos</p>
    </div>

    <!-- Avatares de Fondo -->
    <div class="bg-avatars">
      <!-- Izquierda superior -->
      <div class="bg-avatar bg-avatar-1"><img src="/assets/images/testimonials/maria.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Izquierda medio-alto -->
      <div class="bg-avatar bg-avatar-2"><img src="/assets/images/testimonials/carlos.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Izquierda centro -->
      <div class="bg-avatar bg-avatar-3"><img src="/assets/images/testimonials/ana.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Izquierda inferior -->
      <div class="bg-avatar bg-avatar-4"><img src="/assets/images/testimonials/roberto.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Derecha superior -->
      <div class="bg-avatar bg-avatar-5"><img src="/assets/images/testimonials/lucia.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Derecha medio-alto -->
      <div class="bg-avatar bg-avatar-6"><img src="/assets/images/testimonials/miguel.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Derecha centro -->
      <div class="bg-avatar bg-avatar-7"><img src="/assets/images/testimonials/maria.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
      <!-- Derecha inferior -->
      <div class="bg-avatar bg-avatar-8"><img src="/assets/images/testimonials/carlos.svg" alt="avatar" width="80" height="80" loading="lazy" decoding="async"></div>
    </div>

    <div class="testimonials-container" data-aos="zoom-in" data-aos-delay="200">

      <div class="main-card">
        <swiper [autoHeight]="false" #swiper [config]="swiperConfig" [loop]="true" [autoplay]="{ delay: 5000, disableOnInteraction: false }">
          @for (item of reviews; track $index) {
          <ng-template swiperSlide>
            <div class="review-card">
              <div class="quote-icon">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.75 35C13.75 28.0964 19.3464 22.5 26.25 22.5V15C15.1447 15 6.25 23.8947 6.25 35C6.25 40.1777 8.80127 44.7666 12.6289 47.6895L17.0117 40.3906C15.0391 38.9014 13.75 36.5967 13.75 35Z" fill="#B8A5FF"/>
                  <path d="M33.75 35C33.75 28.0964 39.3464 22.5 46.25 22.5V15C35.1447 15 26.25 23.8947 26.25 35C26.25 40.1777 28.8013 44.7666 32.6289 47.6895L37.0117 40.3906C35.0391 38.9014 33.75 36.5967 33.75 35Z" fill="#B8A5FF"/>
                </svg>
                <!-- <div class="icon-wrapper">
                  <img src="/assets/images/team-members/team-member-1.png" alt="Quote Icon">
                </div> -->
              </div>

              <p class="review-text">{{item.originalText.text}}</p>

              <h3 class="author-name">{{item.authorAttribution.displayName}}</h3>

              <div class="stars-rating">
                <p-rating [(ngModel)]="item.rating" [cancel]="false" [readonly]="true" />
              </div>
            </div>
          </ng-template>
          }
        </swiper>

        <!-- Botones de Navegación -->
        <button class="nav-button prev-button" aria-label="Ver testimonio anterior" (click)="swiper?.swiperRef?.slidePrev()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-button next-button" aria-label="Ver siguiente testimonio" (click)="swiper?.swiperRef?.slideNext()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

    </div>
  </div>
  } @else {
  <app-loader></app-loader>
  }
</section>
